import styled from "styled-components";

export const ModifyHeader = styled.div(
  (props) => `min-width: 144rem;
  	display: flex;
    height: 8.6rem;
    padding: ${props.padding ? props.padding : '1.2rem 0 1.2rem 1.2rem'} ;
    object-fit: contain;
		background-color: ${props.theme.colors.goBrand.orange};
		justify-content: center;
`
);

export const TripType = styled.div`
	width: 10rem;
	height: 1.6rem;
	margin: 0rem 14rem 0.4rem 0rem;
	padding: 0rem 2.5rem 0rem 0rem;
	object-fit: contain;
`;

export const WidgetType = styled.div(
  (props) => `
		width: ${props.width};
		height: 1.6rem;
		padding: 0rem 2.5rem 0rem 0rem;
		border-radius: 0.8rem;
		margin-right: ${props.marginRight || "0"};
		background-color: ${props.theme.colors.goBrand.orange};	
	`);

export const TripTypeTxt = styled.p(
	props => `
		font-stretch: normal;
		font-style: normal;
		letter-spacing: normal;
		font-family: ${props.theme.font.fontFamily};
		font-size: 1.2rem;
		font-weight: normal;
		line-height: 1.33;
		width: 11rem;
		color: ${props.theme.colors.white.base};
	`
);

export const OutStandingWarpper = styled.div(
	props => `
		flex-direction: 'row';
		width: ${props.width};
		height: 4.2rem;
		margin: 0.4rem 1rem 0.0rem 0.0rem;
		padding: 0.9rem 1.2rem 1.1rem 1rem;
		border-radius: 0.8rem;
		background-color: ${props.theme.colors.white.base};
		cursor: pointer;
		display: flex;
	`
);

export const OutStandingInner = styled.p(
	props => `
		height: 2.2rem;
		font-family: 'Rubik';
		font-size: 1.6rem;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.38;
		letter-spacing: normal;
		color: ${props.theme.colors.black.base};
		flex: 1;
		`
);

export const ArrowIcon = styled.div`
	align-content: flex-end;
	justify-content: flex-end;
	padding-top: 0.9rem;
`;

export const OutStandingInputInner = styled.input.attrs(props => (
	{
		...props, 
		...{
			autoFocus: props?.autoFocus || false
		}
	}
))(p => `
		width: ${p.width};
		height: 2.2rem;
		margin: 0 0.7rem 0 0;
		font-family: 'Rubik';
		font-size: 1.6rem;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		border-width:0px;
		border:none;		
		line-height: 1.38;
		letter-spacing: normal;
		background-color: #fff;
		border:none;
	`);

export const UpdateButton = styled.div`
	width: 18.6rem;
  height: 4.2rem;
  margin: 1.7rem 0rem 0.0rem 0.5rem;
  padding: 0.8rem 0.0rem 1rem;
  border-radius: 0.8rem;
	background-color: #ffffff;
	cursor: pointer;
`;

export const updateButtonTxt = styled.p`
	font-family: 'Rubik';
	font-size: 1.8rem;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.33;
	letter-spacing: normal;
	text-align: center;
	color: #2276E3;
	;
`

export const ErrorWrapper = styled.div`
	position: absolute;
`;

export const TripTypeSelection = styled.div`
	top: 15rem;
	background: white;
	box-shadow: 0 2px 14px 0 rgba(0,0,0,0.16);
	border-radius: 1.2rem;
	display: flex;
	flex-direction: column;
	position: absolute;
	width: 30rem;
	z-index: 7;
	max-height: 48rem;
	overflow-y: scroll;
`;

export const ArrowDownIcon = styled.div`
    flex-shrink: 0;
    margin-left: auto;
		font-family: 'Rubik';
		font-size: 1.6rem;
		color: #2276e3;
		display: flex;
		align-items: center;
		font-weight: 600;
		cursor: pointer;
		::after{
			content: "";
			border: solid #141823;
			border-width: 0 0.2rem 0.2rem 0;
			padding: 0.5rem;
			transform: rotate(45deg);
			margin-left: 1rem;
			margin-top: -0.5rem;
		}
`;
